import { render, staticRenderFns } from "./PasswordWithLabel.vue?vue&type=template&id=2d655222"
import script from "./PasswordWithLabel.vue?vue&type=script&lang=ts"
export * from "./PasswordWithLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports